export default {
  auth: () => import("/vercel/path0/layouts/auth.vue"),
  main: () => import("/vercel/path0/layouts/main.vue")
}